import { inject as r } from "vue";
import { errorBannerKey as e } from "./design-system.es12.js";
function t() {
  return r(e);
}
export {
  t as default
};
//# sourceMappingURL=design-system.es11.js.map
